import { createFileRoute } from "@tanstack/react-router";

import { isAuditMember } from "@/core/lib/access";
import { denyRouteAccess } from "@/core/lib/route-access";

export const Route = createFileRoute("/_protected/auditor/")({
  beforeLoad: ({ context, ...guard }) => {
    if (!isAuditMember(context.user)) {
      denyRouteAccess(guard, "audit_membership");
    }
  },
});
